<template>
  <div class="discount-pro-price">
    <div class="price-inf">
      <div class="price-inf-bg">
        <img src="@/assets/down.png" />
      </div>
      <div class="item" style="bottom: 10px;left: 10px;">
        <span>市场价</span>
        <p><del>￥1500</del></p>
      </div>

      <div class="item" style="top: 10px;right: 10px;">
        <p style="font-weight: 600">￥500</p>
        <span>捡漏价</span>
      </div>
    </div>
    <div class="price-desc">
      <p style="color: red; font-size: 14px; margin: 10px 0 ">距离捡漏剩下</p>
      <div style="margin-top: 15px;">
        <van-count-down :time="time">
          <template #default="timeData">
            <span class="block" v-if="timeData.days > 0"
              >{{ timeData.days }}天</span
            >&nbsp;
            <span class="block">{{
              timeData.hours < 10 ? '0' + timeData.hours : timeData.hours
            }}</span>
            <span class="colon">:</span>
            <span class="block">{{
              timeData.minutes < 10 ? '0' + timeData.minutes : timeData.minutes
            }}</span>
            <span class="colon">:</span>
            <span class="block">{{
              timeData.seconds < 10 ? '0' + timeData.seconds : timeData.seconds
            }}</span>
          </template>
        </van-count-down>
      </div>
      <div
        style="display: none;
          background-color: red;
          color: #fff;
          padding: 3px 6px;
          font-size: 14px;
          margin: 6px auto;
          width: 60%;
        "
      >
        已放出1.2万件
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiscountProPriceView',
  data () {
    return {
      active: 1,
      time: 100000000
    }
  }
}
</script>
<style lang="scss" scoped>
.discount-pro-price {
  display: flex;
  padding: 5px 10px;
  gap: 10px;
  border-bottom: 1px solid #7b8c9c;
  .price-inf {
    flex: 1;
    display: flex;
    gap: 4px;
    height: 90px;
    position: relative;
    
    .price-inf-bg {
      position: absolute;
      transform: rotate(180deg);
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      text-align: center;
      img {
        height: 80%;
        width: 80%;
        margin: 10% auto;
      }
    }
    .item {
      flex: 1;
      text-align: center;
      position: absolute;
      span {
        color: #7b8c9c;
        font-size: 14px;
      }
      p {
        color: #d81e06;
        font-size: 18px;
      }
    }
  }

  .price-desc {
    height: 90px;
    flex: 1;
    background: #f7d0f1;
    text-align: center;
  }
}

.colon {
  display: inline-block;
  margin: 0 4px;
  color: #ee0a24;
}
.block {
  color: red;
  font-size: 18px;
  text-align: center;
  background-color: #ffbbc3;
  padding: 4px;
}
</style>
